import React from "react";
import useApplicationListing from "../../customHooks/ApplicationListing/useApplicationListing";
import CreateApplicationModal from "../CreateApplicationModal/CreateApplicationModal";
import usePermission from "../../utils/usePermission";
import UnAuthorized from "../UnAuthorized/UnAuthorized";
import { Accordion } from "react-bootstrap";
import { CiSearch } from "react-icons/ci";
import { FaEye } from "react-icons/fa";
import FullPageLoading from "../../components/FullPageLoading/FullPageLoading";
import Pagination from "react-js-pagination";

const ApplicationListing = () => {
  const {
    handlePageClick,
    handlePageSizeChange,
    handleSearch,
    applications,
    totalCount,
    searchTerm,
    applicationsPerPage,
    currentPage,
    openCreateModal,
    setOpenCreateModal,
    selectedApplication,
    setSelectedApplication,
    fetchApplications,
    loader,
  } = useApplicationListing();
  const canRead = usePermission("APPLICATION_READ");
  const canCreate = usePermission("APPLICATION_CREATE");
  const canUpdate = usePermission("APPLICATION_UPDATE");

  return (
    <div>
      {canRead ? (
        <div className="container">
          <div className="mainHeader">
            <h1 className="font-semibold text-lg">Application</h1>
            {canCreate && (
              <button
                className="add-plan-button"
                onClick={() => {
                  navigate("/plan/create");
                }}
              >
                + Add New Application
              </button>
            )}
          </div>
          <div className="mainHeader">
            <div className="search-container">
              <input
                type="text"
                placeholder="Search..."
                className="search-input"
                value={searchTerm}
                onChange={handleSearch}
              />

              <CiSearch className="search-icon" />
            </div>
          </div>
          {!loader ? (
            <>
              <div className="mainContainer">
                <div className="table-container">
                  <table className="data-table">
                    <thead>
                      <tr>
                        <th>Application Name</th>
                        <th>Application Description</th>
                        {/* <th>Actions</th> */}
                      </tr>
                    </thead>
                    <tbody>
                      {applications.length > 0 ? (
                        <>
                          {applications.map((row, index) => (
                            <tr key={index}>
                              <td>{row.name || "-"}</td>
                              <td>{row.description || "-"}</td>
                            </tr>
                          ))}
                        </>
                      ) : (
                        <tr>
                          <td colSpan={2}>No Applications Found</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>

              {/* <div className="mt-6 flex justify-between items-center">
                <span className="text-gray-600">
                  Showing {(currentPage - 1) * applicationsPerPage + 1} to{" "}
                  {Math.min(currentPage * applicationsPerPage, totalCount)} of{" "}
                  {totalCount} entries
                </span>
                {totalCount > applicationsPerPage && (
                  <Pagination
                    activePage={currentPage}
                    itemsCountPerPage={applicationsPerPage}
                    totalItemsCount={totalCount}
                    pageRangeDisplayed={5}
                    onChange={handlePageClick}
                    nextPageText={">"}
                    prevPageText={"<"}
                    firstPageText={"<<"}
                    lastPageText={">>"}
                    itemClass="page-item"
                    linkClass="page-link"
                  />
                )}
              </div> */}
            </>
          ) : (
            <FullPageLoading />
          )}
        </div>
      ) : (
        <UnAuthorized />
      )}

      <CreateApplicationModal
        show={openCreateModal}
        onHide={setOpenCreateModal}
        id={selectedApplication ? selectedApplication.iApplicationId : null}
        selectedApplication={selectedApplication}
        fetchApplications={fetchApplications}
      />
    </div>
  );
};

export default ApplicationListing;
